module.exports = __webpack_public_path__ + "img/arh_12.412113f2.jpg";